import GroupCurriculum from '@src/pages/GroupCurriculums/GroupCurriculum'
import { LearnerListProvider } from '@logic/contexts/Learners/LearnersListContext.tsx'

export default {
  list: <LearnerListProvider filter={null}><GroupCurriculum /></LearnerListProvider>,
}
